import { Extension } from '@tiptap/core';

export interface FontSizeOptions {
	types: string[];
	sizes: string[];
	defaultSize: string;
}

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		fontSize: {
			setFontSize: (size: string) => ReturnType;
			setNextFontSize: () => ReturnType;
			unsetFontSize: () => ReturnType;
		};
	}
}

export const FontSize = Extension.create<FontSizeOptions>({
	name: 'fontSize',

	addOptions() {
		return {
			types: [],
			sizes: ['normal', 'small', 'smaller', 'smallest'],
			defaultSize: 'normal',
		};
	},

	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					fontSize: {
						default: this.options.defaultSize,
						parseHTML: (element) => element.dataset.fontSize || this.options.defaultSize,
						renderHTML: (attributes) => {
							// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
							return { 'data-font-size': attributes.fontSize };
						},
					},
				},
			},
		];
	},

	addCommands() {
		return {
			setFontSize:
				(size: string) =>
				({ commands }) => {
					if (!this.options.sizes.includes(size)) {
						return false;
					}

					return this.options.types.every((type) =>
						commands.updateAttributes(type, { fontSize: size })
					);
				},

			unsetFontSize:
				() =>
				({ commands }) => {
					return this.options.types.every((type) => commands.resetAttributes(type, 'fontSize'));
				},
			setNextFontSize:
				() =>
				({ commands }) => {
					return this.options.types.every((type) => {
						// This is a convoluted way of satisfying the expected return type of the command
						if (!this.editor.getAttributes(type).fontSize) return true;

						// This feels overly complicated..
						const currentFontSize = this.editor.getAttributes(type).fontSize as string;
						const currentFontSizeIndex = this.options.sizes.indexOf(currentFontSize);
						const nextFontSizeIndex = currentFontSizeIndex + 1;
						const size = this.options.sizes[nextFontSizeIndex] || this.options.sizes[0];
						commands.updateAttributes(type, { fontSize: size });
					});
				},
		};
	},
});
